import { Container } from '@mui/material';
import {
  PageHeader as SharedPageHeader,
  type PageHeaderProps,
} from '@tix-ticketing/ui-components';

export const PageHeader = (props: PageHeaderProps) => (
  <Container>
    <SharedPageHeader {...props} />
  </Container>
);
